export const TOTAL_BUCKETS = 6

export const getBucketBoundariesAndLabels = (timeRange: { id: string; label: string }, alerts: any[]): { boundaries: Date[]; labels: string[] } => {
    let boundaries: Date[] = []
    let labels: string[] = []
    if (timeRange.id === 'all' && alerts.length > 0) {
        const sortedAlerts = [...alerts].sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())
        const firstDate = new Date(sortedAlerts[0].createdAt)
        firstDate.setHours(0, 0, 0, 0)
        const lastDate = new Date(sortedAlerts[sortedAlerts.length - 1].createdAt)
        lastDate.setHours(23, 59, 59, 999)
        const totalDays = Math.max(1, Math.floor((lastDate.getTime() - firstDate.getTime()) / (1000 * 60 * 60 * 24)))
        boundaries = Array.from({ length: TOTAL_BUCKETS + 1 }, (_, i) => {
            if (i === 0) return new Date(firstDate)
            if (i === TOTAL_BUCKETS) return new Date(lastDate)
            const d = new Date(firstDate)
            d.setDate(firstDate.getDate() + Math.round(i * (totalDays / TOTAL_BUCKETS)))
            d.setHours(0, 0, 0, 0)
            return d
        })
    } else {
        const filterDays = parseInt(timeRange.id)
        const today = new Date()
        today.setHours(23, 59, 59, 999)
        const startDate = new Date(today)
        startDate.setDate(today.getDate() - filterDays)
        startDate.setHours(0, 0, 0, 0)
        boundaries = Array.from({ length: TOTAL_BUCKETS + 1 }, (_, i) => {
            const d = new Date(startDate)
            d.setDate(startDate.getDate() + Math.round(i * (filterDays / TOTAL_BUCKETS)))
            if (i === TOTAL_BUCKETS) d.setHours(23, 59, 59, 999)
            else d.setHours(0, 0, 0, 0)
            return d
        })
    }
    labels = boundaries.slice(0, -1).map((d) => `${d.getDate()} ${d.toLocaleString('en-US', { month: 'short' })}`)
    return { boundaries, labels }
}